"use strict";
var utilities_1 = require("./utilities");
exports.filter = utilities_1.filter;
exports.check = utilities_1.check;
exports.propType = utilities_1.propType;
var graphql_1 = require("./graphql");
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = graphql_1.graphql;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/graphql-anywhere/lib/src/index.js
// module id = 929
// module chunks = 40